/**
 * App.Store - 全局状态中枢
 */

import type { Floor, Cell, Vertex, Room, End, Shaft, System } from '../types';
import { TileType } from '../types';
import { App } from './App';

/* ─────────────── Module: Store（全局状态中枢）─────────────── */
App.Store = {
  /** 楼层数组（多楼层） */
  floors: [] as Floor[],

  /** 当前激活楼层（便捷引用 = floors[activeFloorIdx]） */
  f: null as Floor | null,

  /** 当前活动楼层索引 */
  activeFloorIdx: 0,

  /** 楼层命名计数 */
  floorCounter: 1,

  /** 视图/编辑状态（非场景数据） */
  mode: 'edit',
  bindMode: false,
  layoutIdx: 0,
  planView: false,
  theme: 'dark' as 'dark' | 'light',

  /** 机房/末端命名计数 */
  roomCounter: 1,
  endCounter: 4,

  /** 竖井注册表（跨层立管的唯一数据源）与编号计数 */
  shafts: [] as Shaft[],
  shaftCounter: 0,

  /** 管线系统注册表（给水/排水/暖通/电气等）与计数 */
  systems: [] as System[],
  systemCounter: 0,

  /** 当前活动系统（新建机房/末端默认归属） */
  activeSystemId: 0,

  /** 折弯惩罚权重（成本权重可调：最短 vs 最少折弯） */
  cornerPenalty: 0,

  /** 流向动画开关（路径上光点从机房流向末端） */
  flowAnim: true,

  /** 末端批量管理面板的选中末端ID（UI 状态，不进快照） */
  selectedEndIds: new Set<string>(),

  /** 寻路结果 */
  results: [],

  /** 是否正在运行寻路 */
  running: false,

  /** 连线模式当前顶点 */
  curLine: [] as Vertex[],

  /** 当前悬停格子 */
  hoverCell: null as Cell | null,

  /** 拖拽状态 */
  dragEnd: null as End | null,
  dragRoom: null as Room | null,
  dragMoved: false,
  downCell: null as Cell | null,
  downOnEnd: null as End | null,
  downX: 0,
  downY: 0,

  /** 机房拖拽偏移 */
  roomGrabDX: 0,
  roomGrabDZ: 0,

  /**
   * 创建新楼层对象
   * @param id 楼层ID
   * @param name 楼层名称
   * @param yBase 世界Y坐标基准
   */
  newFloor(id?: string, name?: string, yBase?: number): Floor {
    return {
      id: id || 'F1',
      name: name || '一层',
      yBase: yBase || 0,
      type: [],
      rooms: [],
      ends: [],
      lines: [],
      drawnCells: new Set<string>(),
      drawnOrig: new Map<string, TileType>(),
      endOrig: new Map<string, TileType>(),
      roomOrig: new Map<string, TileType>(),
      riserOrig: new Map<string, TileType>(),
      junctions: [],
      bindings: new Map<string, Set<string>>(),
    };
  },

  /**
   * 楼层增删后重排：yBase连续、floorIdx重新对齐索引
   */
  reindexFloors(): void {
    const C = App.Config;
    this.floors.forEach((f, i) => {
      f.yBase = i * C.FLOOR_HEIGHT;
      f.rooms.forEach(r => r.floorIdx = i);
      f.ends.forEach(e => e.floorIdx = i);
    });
  },
};

export default App.Store;
export const Store = App.Store;
